/* These mixins are designed to work with PC transactions only (both New and Edit)
 * Assumes parent component has all necessary data elements
 * e.g. Vuex store, ElementUI, etc.
*/

export const pettycashMixins = {
  methods: {
    // For PC accounts, lookup the PC vendor's balance.  Requires vendor to have a PC account
    // Also looks up the cash in bank account for advances.  TODO. setup a custodian or pc bank to lookup
    async setPcBalance (vendorId, onlyCashAcct = false) {
      const { batch } = this.form
      if (!(batch && batch.value)) return false
      let pettyCashAccounts = []
      let pcAccount = {}
      let pCardAccount = {}
      let bank = {}
      let bankCashAcct = {}

      if (!this.getBankByBatchId(batch.value)) {
        await this.$store.dispatch('fetchBanksWithQuery', { active: 'True' })
      }

      let vendor = this.getVendorById(vendorId)
      if (vendor.petty_cash_p_card_enabled && vendor.petty_cash_p_card_account) { // PCard Account
        pCardAccount = this.getAccountById(vendor.petty_cash_p_card_account)
        if (pCardAccount && !pCardAccount.id) {
          pettyCashAccounts.push(vendor.petty_cash_p_card_account)
        }
      }
      if (vendor.petty_cash_account) { // PCash Account
        pcAccount = this.getAccountById(vendor.petty_cash_account)
        if (pcAccount && !pcAccount.id) {
          pettyCashAccounts.push(vendor.petty_cash_account)
        }
      }

      // Default PC bank is 1) defined by setting "DEFAULT_PC_CUSTODIAN".  If not defined, the bank's default cash account
      const defaultCustodianSetting = JSON.parse(this.$store.getters.getUiSettings['DEFAULT_PC_CUSTODIAN'] || '{}') || null
      const defaultCustodianAcct = (defaultCustodianSetting || {}).id ? this.getAccountById(defaultCustodianSetting.id) : null
      let defaultCashAcct = defaultCustodianAcct || bankCashAcct || null

      bank = this.getBankByBatchId(batch.value)
      if (bank && bank.default_account_cash) {
        bankCashAcct = this.getAccountById(bank.default_account_cash)
        if (bankCashAcct && !bankCashAcct.id) {
          pettyCashAccounts.push(bank.default_account_cash)
        } else {
          defaultCashAcct = bankCashAcct || null
        }
      }

      if (pettyCashAccounts.length) {
        this.$store.dispatch('fetchAccountsWithQuery', { id__in: [...new Set(pettyCashAccounts)], page_size: pettyCashAccounts.length })
          .then((res) => {
            if (res.count) {
              if (vendor.petty_cash_account && !pcAccount.hasOwnProperty('id')) {
                pcAccount = this.getAccountById(vendor.petty_cash_account)
                this.form.pcAccount = pcAccount
              }
              if (vendor.petty_cash_p_card_enabled && vendor.petty_cash_p_card_account && !pCardAccount.hasOwnProperty('id')) {
                pCardAccount = this.getAccountById(vendor.petty_cash_p_card_account)
                this.form.pCardAccount = pCardAccount
              }
              if (bank && bank.default_account_cash && !bankCashAcct.hasOwnProperty('id')) {
                bankCashAcct = this.getAccountById(bank.default_account_cash)
                this.form.cashAccount = bankCashAcct || null
                if (onlyCashAcct) {    // return if only cash account is required
                  return
                }
              }

              // Lookup balance here
              let pcAccountBalance = this.getAccountBalanceByCode(pcAccount.code)
              if (bank && pcAccount && pcAccount.id && !pcAccountBalance.balance) {
                this.$store.dispatch('fetchAccountBalanceById', { id: pcAccount.id, currency: bank.currency, includeItems: true })
                  .then((response) => {
                    if (response && response.balance) {
                      this.form.amount_beginning_pc_decimal = response.balance
                      return response.balance
                    }
                    return ''
                  })
                  .then(responseBalance => {
                    this.form.amount_remaining_pc_decimal = this.amount_pc_balance.toFixed(2)
                  })
                  .catch(e => console.log(e))
              } else if (bank && pcAccount && pcAccount.id && pcAccountBalance.balance) {
                this.form.amount_beginning_pc_decimal = pcAccountBalance.balance
              } else {
                this.form.amount_beginning_pc_decimal = '0.00'
              }
            }
          })
      } else {
        this.form.pcAccount = pcAccount
        this.form.pCardAccount = pCardAccount

        // Get cash account
        if (!(defaultCashAcct && Object.keys(defaultCashAcct).length)) return false
        this.form.cashAccount = defaultCashAcct
        if (onlyCashAcct) {    // return if only cash account is required
          return
        }

        // Lookup balance here
        let pcAccountBalance = this.getAccountBalanceByCode(pcAccount.code)
        if (bank && pcAccount && pcAccount.id && !pcAccountBalance.balance) {
          this.$store.dispatch('fetchAccountBalanceById', { id: pcAccount.id, currency: bank.currency, includeItems: true })
            .then((response) => {
              if (response && response.balance) {
                this.form.amount_beginning_pc_decimal = response.balance
                return response.balance
              }
              return ''
              // this.form.amount_beginning_pc_decimal = this.getAccountBalanceByCode(pcAccount.id).balance
            })
            .then(responseBalance => {
              this.form.amount_remaining_pc_decimal = this.amount_pc_balance.toFixed(2)
            })
            .catch(e => console.log(e))
        } else if (bank && pcAccount && pcAccount.id && pcAccountBalance.balance) {
          this.form.amount_beginning_pc_decimal = pcAccountBalance.balance
        } else {
          this.form.amount_beginning_pc_decimal = '0.00'
        }
      }
    },
    /**
     * Manual way to search distribution lines to match our special lines.  It's imperfect, but it's a start until we can store additional comments/metadata in the transactions.
     * @param lines
     * @return {boolean}
     */
    getSpecialPcLines (lines) {
      if (!lines || lines.length <= 0) return false
      this.specialPcLines.envelope = lines.findIndex(line => {
        return line && line.form
          ? ['PETTY CASH OFFSET', 'PCARD OFFSET'].includes(line.form.description) || line.form.description.match('PETTY CASH OFFSET') || line.form.description.match('PCARD OFFSET')
          : ['PETTY CASH OFFSET', 'PCARD OFFSET'].includes(line.description) || line.description.match('PETTY CASH OFFSET') || line.description.match('PCARD OFFSET')
      })
      this.specialPcLines.advance = lines.findIndex(line => {
        return line && line.form
          ? line.form.description.match('PETTY CASH ADVANCE')
          : line.description.match('PETTY CASH ADVANCE')
      })
      this.specialPcLines.reimbursement = lines.findIndex(line => {
        return line && line.form
          ? line.form.description.match('PETTY CASH REIMBURSEMENT')
          : line.description.match('PETTY CASH REIMBURSEMENT')
      })
    },
    /**
     * Function to build a new AP based on the current PC Envelope
     */
    buildReimbursementTransaction () {
      let amount = (this.amount_pc_balance < 0) ? (this.amount_pc_balance * -1).toFixed(2) : false
      // Added '&& this.specialPcLines.envelope > -1' because, since this.specialPcLines is generated using `lines.findIndex`,
      // -1 will be returned in cases where no match is found. However, -1 is not a valid index in this.lines, and thus
      // `this.lines[row].form...` will not refer to anything but will throw an error.
      let row = (this.specialPcLines && this.specialPcLines.envelope && this.specialPcLines.envelope > -1) ? this.specialPcLines.envelope : 0
      const vendor = () => {
        if (!this.form.vendor) return ''
        const model = this.$store.getters.getVendorById(this.form.vendor.value) || {}
        if (model && model.id) {
          return model.name
        }
        return this.form.vendor.label || ''
      }
      if (amount !== false) {
        return {
          header: {
            amount_decimal: amount,
            batch: this.form.batch.value,
            date: this.form.date,
            description: 'PC REIMBURSEMENT ' + vendor(),
            number: 'PC #' + this.form.number,
            payment_check_pickup: false,
            payment_combine_checks: true,
            payment_type: 'CHECK',
            period: this.form.period,
            vendor: this.form.vendor.value
          },
          lines: [
            {
              line_number: 1,
              account: this.form.pcAccount.id,
              amount_decimal: amount,
              asset: false,
              description: 'PC REIMUBURSEMENT ' + vendor(),
              series: this.lines[row].form.series.value,
              location: this.lines[row].form.location.value,
              set: this.lines[row].form.set.value,
              free_field_1: null,
              free_field_2: null,
              tax_code: null,
              relieves: null,
              third_party_vendor: ''
            }
          ]
        }
      } else {
        return false
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/Mixins/PettyCash.js